"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeTotalWeight = computeTotalWeight;
const big_js_1 = __importDefault(require("big.js"));
function computeTotalWeight(lines) {
    return lines
        .reduce((totalWeight, line) => totalWeight.plus((0, big_js_1.default)(line.weightInGrams || 0).times(line.quantity)), (0, big_js_1.default)(0))
        .toNumber();
}
